<script>
import MobileFooter from '../../reusableitems/mobileFooter.svelte';
import Mobilebtn1 from '../mobilebtn.svelte';
import {initializeGsapAnimation} from '../../utils.js';
import {onMount} from 'svelte';

let main;
let backClr;
let text1;
let text2;
let text3;

onMount(onStart);
/**
 */
function onStart() {
    initializeGsapAnimation(main, backClr, [{background: '#F4EEEC', duration: 3}, {y: '7.523vw', duration: 3}], 3);
    initializeGsapAnimation(main, text1, [{y: '-6vw', duration: 3}, {y: '0vw', duration: 3}], 3);
    initializeGsapAnimation(main, text2, [{y: '-36.449vw', duration: 3}, {y: '0vw', duration: 3}], 3);
    initializeGsapAnimation(main, text3, [{y: '-30.477vw', duration: 3}, {y: '0vw', duration: 3}], 3);
}
</script>

<section bind:this={main}>
    <div class="main-div" bind:this={backClr}>
        <div class="text" bind:this={text1}><p>6</p></div>

        <div class="container">
            <div class="div1" bind:this={text2}>
                <p class="p1">Musicians & Sound Artists</p>
            </div>
            <div class="div2" bind:this={text3}>
                <p class="p2">
                    No party is complete without music. <br /><br /> We’re
                    gathering the most innovative creative around the globe to
                    tinker, converse and decide the future of entertainment and
                    gaming. <br /><br />
                    <strong
                        >You're awarded an exclusive ticket to the party. Govern
                        the rules of community and vote on the direction of the
                        technology and get rewarded for it.</strong
                    > <br /><br /> And while you’re at it, let's agree on an official
                    soundtrack (we won’t stop you if you want to compose one, promise!).
                </p>
            </div>
            <div class="div3">
                <Mobilebtn1
                    width=" 56.308vw"
                    height=" 10.047vw"
                    txtsize="2.336vw"
                    txtsize2="1.869vw"
                    txtcolor="#FFFFFF"
                    bgcolor="#4F81BB"
                    text2="(Music Seat)"
                    state = "Artists & Musicians"
                />
            </div>
            <div class="div4">
                <img src="images/Artist/ArtistMobile/SoundArtist.png" alt="" />
            </div>
            <div class="soundvec">
                <img
                    src="images/Artist/vectorsound.png"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
        </div>
        <div style=" position: absolute;bottom: 0vw;width: 100%;">
            <MobileFooter />
        </div>
    </div>
</section>

<style>
    .main-div {
        background-color: #4d4d4d;
        overflow: hidden;
        width: 100%;
        height: max(100vh,216.335vw);
        position: relative;
    }
    .div1 {
        width: 85.981vw;
        height: 14.019vw;
        margin-bottom: max(7.009vw, 3.24vh);
        margin-left: max(4.673vw, 2.16vh);
        position: absolute;
        bottom: max(120vw,55.55vh);
    }

    .div2 {
        width: 67.523vw;
        height: 59.579vw;
        margin-left: max(4.673vw, 2.16vh);
        margin-bottom: max(7.243vw, 3.348vh);
        position: absolute;
        bottom: 55vw;
    }
    .div3 {
        margin: auto;
        /* margin-bottom: 7.477vw; */
    }
    .div4 {
        height: 71.262vw;
        width: 100%;
    }
    .div4 img {
        height: 100%;
        width: 100%;
    }
    .p1 {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 7.009vw;
        line-height: 100%;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: #000000;
    }

    .p2 {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 2.804vw;
        line-height: 140%;
        letter-spacing: 0.06em;
        color: #000000;
    }

    .text {
        position: absolute;
        left: 20vw;
        top: max(6vw,2.777vh);
    }

    .text p {
        margin: 0;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 140.187vw;
        line-height: 100%;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: #ffffff;
    }
    .container {
        position: absolute;
        bottom: max(10.981vw, 5.076vh);
        width: 100%;
    }
    .soundvec {
        position: absolute;
        bottom: max(4.5vw,2.08vh);
        width: 84.729vw;
        height: 65.729vw;
        left: 7.3vw;
        animation: move 0.4s infinite;
    }
    @keyframes move {
        0% {
            transform: scale(1.03);
        }
        100% {
            transform: scale(1);
        }
    }
</style>
